"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLayout_1 = __importDefault(require("../../Layouts/AppLayout"));
function Show() {
    return (react_1.default.createElement(AppLayout_1.default, { title: 'Rewards', renderHeader: function () { return (react_1.default.createElement("h2", { className: "font-semibold text-xl text-gray-800 leading-tight" }, "Rewards")); } },
        react_1.default.createElement("div", null, "Rewards")));
}
exports.default = Show;
